import React, { useState } from "react";
import moment from "moment";
import useInterval from "use-interval";

export const Date = () => {
  const today = moment().format("dddd MMMM Do")
  const [date, setDate] = useState(today);
  
  useInterval(() => {
    setDate(today);
  }, 1000);
 
  return (
    <>
       <section className="date-wrapper">
         <h4 className="date">{date}</h4>
       </section>
    </>
  );
};
